import { useCallback, useState } from "react";
import localStore from "./local-store";

export interface PanelPath {
    path: string,
    name: string,
}

export interface SideStatus {
    selectedPanel: string,
    setSelectedPanelValue: (e: string) => void

    needRenderDataBoxSide: () => void
    needRenderSensorSide: () => void
}

export function useSideService() {
    const [selectedPanel, setSelectedPanel] = useState<string>(''); // 侧边打开的panel内容
    const [renderDataBoxFlag, setRenderDataBoxFlag] = useState<boolean>(false); // 重新渲染采集箱侧边栏
    const [renderSensorFlag, setRenderSensorFlag] = useState<boolean>(false); // 重新渲染传感器侧边栏

    const setSelectedPanelValue = useCallback((value: string) => {
        setSelectedPanel(value);
        localStore.setSelectedPanel(value);
    }, [selectedPanel])

    const needRenderDataBoxSide = useCallback(() => {
        setRenderDataBoxFlag(pre => !pre);
    }, [renderDataBoxFlag])

    const needRenderSensorSide = useCallback(() => {
        setRenderSensorFlag(pre => !pre);
    }, [renderSensorFlag])

    return {
        selectedPanel,
        setSelectedPanelValue,
        renderDataBoxFlag,
        needRenderDataBoxSide,
        renderSensorFlag,
        needRenderSensorSide,
    }
}